<script setup lang="ts">
useHead({
  htmlAttrs: {
    lang: 'en',
  },
  link: [ { href: '/favicon.ico', rel: 'icon' } ],
  meta: [ { content: 'width=device-width, initial-scale=1', name: 'viewport' } ],
})

</script>

<template>
  <a href="#main-content" class="absolute left-0 top-0 bg-blue-500 text-white py-2 px-4 z-50 transform -translate-y-full focus:translate-y-0 transition">
    Skip to main content
  </a>
  <AppHeader/>

  <UMain id="main-content">
    <NuxtPage/>
  </UMain>

  <AppFooter/>

  <UNotifications/>
</template>
